import StoryblokLink from "../link/StoryblokLink";
import RichTextWithBlokRenderer from "../richTextRenderer/richTextRenderer";
import styles from "./textAndLinkCard.module.scss";

function TextAndLinkCard({ blok }) {
  return (
    <div className={styles.root}>
      <h3 className={styles.header}>{blok.header}</h3>
      <div className={styles.contentWrapper}>
        <RichTextWithBlokRenderer
          document={blok.content}
        />
      </div>
      <div className={styles.divider} />
      <StoryblokLink linkObject={blok.linkUrl} className={styles.link}>{blok.linkText}</StoryblokLink>
    </div>
  );
}

export default TextAndLinkCard;
